import styled from 'styled-components';

// CONSTANTS
import { PANACHE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';
import { getS3ImageUrl } from '@/utility/content';

const bgTop = getS3ImageUrl('/live-tv/libe-tv-banner-bg-top.png');
const bgBottom = getS3ImageUrl('/live-tv/live-tv-banner-bg-bottom.png');

export const Container = styled.div`
  position: relative;
  padding: 50px 0;
  background-color: ${PANACHE};

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: ${PANACHE};
  }

  &::before {
    right: 100%;
  }

  &::after {
    left: 100%;
  }

  .banner-live-tv {
    &__content {
      position: relative;
      z-index: 2;
    }

    &__bg-top {
      position: absolute;
      top: 0;
      left: -15%;
      height: 390px;
      width: 406px;
      background-image: url(${bgTop});
      z-index: 1;
    }

    &__bg-bottom {
      position: absolute;
      top: 0;
      right: -15%;
      height: 518px;
      width: 593px;
      background-image: url(${bgBottom});
      z-index: 1;
    }

    &__title {
      padding-top: 30px;
      margin-bottom: 15px;
    }

    &__subtitle {
      font-size: 1.8rem;
      line-height: 3rem;
      font-weight: 500;
      margin-bottom: 30px;
    }

    &__button {
      min-width: 230px;
    }

    &__image {
      text-align: right;

      img {
        max-width: 100%;
      }
    }
  }

  ${breakpoints.down('sm')} {
    .banner-live-tv {
      &__title {
        padding-top: 0;
      }
    }
  }

  ${breakpoints.down('xs')} {
    text-align: center;
    padding: 40px 0;

    .banner-live-tv {
      &__title {
        margin-bottom: 8px;
      }

      &__subtitle {
        margin-bottom: 20px;
      }

      &__button {
        min-width: auto;
        margin-bottom: 10px;
      }

      &__image {
        text-align: center;
      }

      &__bg-bottom {
        max-height: 460px;
      }
    }
  }
`;

export default Container;
